import React, { useEffect, useState } from 'react';

const UserContext = React.createContext(null);

const UserProvider = ({ children }) => {
  const [token, setToken] = useState(null);

  // Load token from localStorage on mount
  useEffect(() => {
    const storedToken = localStorage.getItem('token')
    if (storedToken) {
      setToken(storedToken)
    }
  }, []);

  // Update token state and persist in localStorage
  const handleSetToken = (newToken) => {
    setToken(newToken);
    if (newToken) {
      localStorage.setItem('token', newToken);
    } else {
      localStorage.removeItem('token');
    }
  }

  return (
    <UserContext.Provider value={{ token, setToken: handleSetToken }}>
      {children}
    </UserContext.Provider>
  )
}

export { UserContext, UserProvider }
